import { render } from "./PackageForm.vue?vue&type=template&id=0019f907&scoped=true"
import script from "./PackageForm.vue?vue&type=script&lang=js"
export * from "./PackageForm.vue?vue&type=script&lang=js"

import "./PackageForm.vue?vue&type=style&index=0&id=0019f907&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0019f907"]])

export default __exports__